import { useEffect } from 'react';
import { useFormik } from 'formik';
import { PqrInFavorOf } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrInFavorOf = (inFavorOf?: PqrInFavorOf) => {
    const formik = useFormik({
        initialValues: {
            inFavorOf: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            inFavorOf: useGetNameOrValue(inFavorOf?.inFavorOf || ''),
        });
    }, [inFavorOf]);

    return {
        formik,
    };
};
